module.exports = __webpack_public_path__ + "media/images/network-community-e3b4e50410b2efe6c5b1871eb254995a.svg";